export function formatFileSize(bytes: number): string {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
}

/**
 * Check if a file already exists in the files array.
 * Files are considered duplicates if they have the same name and size.
 */
export function isFileDuplicate(file: File, existingFiles: File[]): boolean {
  return existingFiles.some(
    (existingFile) => existingFile.name === file.name && existingFile.size === file.size,
  );
}

/**
 * Filter out duplicate files from an array of files.
 * Only keeps files that don't already exist in the existingFiles array.
 */
export function filterDuplicateFiles(newFiles: File[], existingFiles: File[]): File[] {
  return newFiles.filter((file) => !isFileDuplicate(file, existingFiles));
}
